var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthNobg = function SvgEthNobg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eth_nobg_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.998.334-.143.486v14.106l.143.143 6.547-3.87L10.998.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.997.334 4.45 11.198l6.548 3.87V.335ZM10.997 16.308l-.081.098v5.025l.08.235 6.552-9.226-6.551 3.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.997 21.666v-5.358L4.45 12.44l6.548 9.226ZM10.996 15.07l6.548-3.871-6.548-2.976v6.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.45 11.199 6.547 3.87V8.223L4.45 11.199Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eth_nobg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.333 .333)",
    d: "M0 0h21.333v21.333H0z"
  })))));
};
export default SvgEthNobg;